import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// import { getVisibleItems } from '../../selectors'
import { setValueFilter, setFieldFilter } from '../../actions'
import Dropdown from './Dropdown'

class SearchBar extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      freeword: '',
      secondaryTerm: '',
      errorMessage: ''
    }
  }
  _updateFreeword (e) {
    this.setState({ freeword: e.target.value })
    this.props.setValueFilter(e.target.value)
  }
  _updateSecondaryTerm (newTermID) {
    this.setState({ secondaryTerm: newTermID })
    this.props.setFieldFilter(newTermID)
  }

  _handleSubmit (e) {
    e.preventDefault()
    if (!this.state.secondaryTerm) {
      this.setState({ errorMessage: '*項目を選択してください。' })
    }
    if (this.state.freeword && this.state.secondaryTerm) {
      this.setState({ errorMessage: '' })
      this.props.handleFilterSubmit(this.state.secondaryTerm, this.state.freeword)
    }
  }

  render () {
    // console.log('rendering search bar')
    return (
      <form className="search_bar" onSubmit={this._handleSubmit.bind(this)}>
        <div className="row flex justify-between">
          <div className="input-group flex">
            <input
              type="text"
              id="freeword"
              placeholder="検索ワードを入力して下さい。"
              onChange={this._updateFreeword.bind(this)}
              value={this.state.freeword}
            />

          </div>
          <Dropdown
            updateTerm={this._updateSecondaryTerm.bind(this)}
            choices={this.props.labels}
          />
        </div>
        <div className="error_msg small text-center">{this.state.errorMessage}</div>
      </form>
    )
  }
}

SearchBar.propTypes = {
  onSubmit: PropTypes.func,
  category: PropTypes.string,
  freeword: PropTypes.string,
  secondaryTerm: PropTypes.string
}

SearchBar.defaultProps = {

}

// function mapStateToProps ({ list }) {
//   return { list }
// }

export default connect(null, { setValueFilter, setFieldFilter })(SearchBar)
// export default SearchBar



// WEBPACK FOOTER //
// ./src/components/_common/SearchBar.js